import {
  ConnectComponentsProvider,
  ConnectPayouts,
} from "@stripe/react-connect-js"
import PropTypes from "prop-types"
import React from "react"

const StripeConnectPayouts = ({ stripeConnectInstance }) => {
  if (!stripeConnectInstance) {
    return null
  }

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectPayouts />
    </ConnectComponentsProvider>
  )
}

StripeConnectPayouts.propTypes = {
  stripeConnectInstance: PropTypes.object,
}

export default StripeConnectPayouts
